/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ExportJobDto } from '../models/export-job-dto';
import { exportsExportJobIdDownloadGet$Json } from '../fn/exports/exports-export-job-id-download-get-json';
import { ExportsExportJobIdDownloadGet$Json$Params } from '../fn/exports/exports-export-job-id-download-get-json';
import { exportsExportJobIdDownloadGet$Plain } from '../fn/exports/exports-export-job-id-download-get-plain';
import { ExportsExportJobIdDownloadGet$Plain$Params } from '../fn/exports/exports-export-job-id-download-get-plain';
import { exportsExportJobIdGet$Json } from '../fn/exports/exports-export-job-id-get-json';
import { ExportsExportJobIdGet$Json$Params } from '../fn/exports/exports-export-job-id-get-json';
import { exportsExportJobIdGet$Plain } from '../fn/exports/exports-export-job-id-get-plain';
import { ExportsExportJobIdGet$Plain$Params } from '../fn/exports/exports-export-job-id-get-plain';
import { exportsPost$Json } from '../fn/exports/exports-post-json';
import { ExportsPost$Json$Params } from '../fn/exports/exports-post-json';
import { exportsPost$Plain } from '../fn/exports/exports-post-plain';
import { ExportsPost$Plain$Params } from '../fn/exports/exports-post-plain';

@Injectable({ providedIn: 'root' })
export class ExportsApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `exportsPost()` */
  static readonly ExportsPostPath = '/exports';

  /**
   * Enqueue export.
   *
   * Creates an export job for a query or dashboard.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  exportsPost$Plain$Response(params?: ExportsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportJobDto>> {
    const obs = exportsPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Enqueue export.
   *
   * Creates an export job for a query or dashboard.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  exportsPost$Plain(params?: ExportsPost$Plain$Params, context?: HttpContext): Observable<ExportJobDto> {
    const resp = this.exportsPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ExportJobDto>): ExportJobDto => r.body)
    );
  }

  /**
   * Enqueue export.
   *
   * Creates an export job for a query or dashboard.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportsPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  exportsPost$Json$Response(params?: ExportsPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportJobDto>> {
    const obs = exportsPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Enqueue export.
   *
   * Creates an export job for a query or dashboard.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportsPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  exportsPost$Json(params?: ExportsPost$Json$Params, context?: HttpContext): Observable<ExportJobDto> {
    const resp = this.exportsPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ExportJobDto>): ExportJobDto => r.body)
    );
  }

  /** Path part for operation `exportsExportJobIdGet()` */
  static readonly ExportsExportJobIdGetPath = '/exports/{exportJobId}';

  /**
   * Get export job.
   *
   * Returns status and metadata of an export job.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportsExportJobIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportsExportJobIdGet$Plain$Response(params: ExportsExportJobIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportJobDto>> {
    const obs = exportsExportJobIdGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get export job.
   *
   * Returns status and metadata of an export job.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportsExportJobIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportsExportJobIdGet$Plain(params: ExportsExportJobIdGet$Plain$Params, context?: HttpContext): Observable<ExportJobDto> {
    const resp = this.exportsExportJobIdGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ExportJobDto>): ExportJobDto => r.body)
    );
  }

  /**
   * Get export job.
   *
   * Returns status and metadata of an export job.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportsExportJobIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportsExportJobIdGet$Json$Response(params: ExportsExportJobIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportJobDto>> {
    const obs = exportsExportJobIdGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get export job.
   *
   * Returns status and metadata of an export job.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportsExportJobIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportsExportJobIdGet$Json(params: ExportsExportJobIdGet$Json$Params, context?: HttpContext): Observable<ExportJobDto> {
    const resp = this.exportsExportJobIdGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ExportJobDto>): ExportJobDto => r.body)
    );
  }

  /** Path part for operation `exportsExportJobIdDownloadGet()` */
  static readonly ExportsExportJobIdDownloadGetPath = '/exports/{exportJobId}/download';

  /**
   * Download export.
   *
   * Downloads the exported file for a completed job.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportsExportJobIdDownloadGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportsExportJobIdDownloadGet$Plain$Response(params: ExportsExportJobIdDownloadGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = exportsExportJobIdDownloadGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Download export.
   *
   * Downloads the exported file for a completed job.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportsExportJobIdDownloadGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportsExportJobIdDownloadGet$Plain(params: ExportsExportJobIdDownloadGet$Plain$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.exportsExportJobIdDownloadGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * Download export.
   *
   * Downloads the exported file for a completed job.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportsExportJobIdDownloadGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportsExportJobIdDownloadGet$Json$Response(params: ExportsExportJobIdDownloadGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = exportsExportJobIdDownloadGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Download export.
   *
   * Downloads the exported file for a completed job.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportsExportJobIdDownloadGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportsExportJobIdDownloadGet$Json(params: ExportsExportJobIdDownloadGet$Json$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.exportsExportJobIdDownloadGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
